import { useNavigate } from 'react-router-dom';
interface CustomMenuOption {
  label: string;
  value: string;
  path: string;
}

function CustomTabMenu({
  selectedMenuTab,
  setSelectedMenuTab,
  screenView,
  menuOptions,
  prefixPath,
  widthOverride,
  disabled,
}: {
  selectedMenuTab: string;
  setSelectedMenuTab: (tab: string) => void;
  screenView: string;
  menuOptions: CustomMenuOption[];
  prefixPath: string;
  widthOverride?: string;
  disabled?: boolean;
}) {
  const navigate = useNavigate();
  const renderScreenView = (screenView: string) => {
    switch (screenView) {
      case 'desktop':
      case 'tablet':
      case 'mobile':
        return (
          <div
            className={`flex h-[34px] max-h-[34px] md:h-[46px] md:max-h-[46px] ${!widthOverride ? 'w-[285px] max-w-[285px]' : widthOverride} flex-row items-center justify-between rounded-full border-[1px] border-[#EAECF0] bg-white align-middle text-[#717682]`}
          >
            {menuOptions.map((option: CustomMenuOption) => {
              const fullPath = `${prefixPath}${option.path}`;
              return (
                <button
                  key={option.value}
                  disabled={disabled}
                  onClick={() => {
                    setSelectedMenuTab(option.value);
                    navigate(fullPath);
                  }}
                  className={`${
                    selectedMenuTab === option.value
                      ? 'rounded-full border-[1px] border-[#F7A826] bg-[#FEF6E9] px-2 py-1 text-[#312F36] disabled:cursor-not-allowed md:px-[32px] md:py-[10px]'
                      : 'rounded-full px-2 py-1 md:px-[32px] md:py-[10px]'
                  }`}
                >
                  {option.label}
                </button>
              );
            })}
          </div>
        );
    }
  };
  return <>{renderScreenView(screenView)}</>;
}

export default CustomTabMenu;
